"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    cardFooterClassNames: function() {
        return cardFooterClassNames;
    },
    useCardFooterStyles_unstable: function() {
        return useCardFooterStyles_unstable;
    }
});
const _react = require("@griffel/react");
const cardFooterClassNames = {
    root: 'fui-CardFooter',
    action: 'fui-CardFooter__action'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Beiy3e4: "f1063pyq",
        i8kkvl: 0,
        Belr9w4: 0,
        rmohyg: "fsbu5mz"
    },
    action: {
        Frg6f3: [
            "fcgxt0o",
            "f1ujusj6"
        ],
        B7frvx2: "f1ndzpm5",
        B06c7xf: [
            "f1fkeggc",
            "f1u45u6i"
        ],
        B8uq84v: "f16eyofs",
        snkdo8: [
            "f1u45u6i",
            "f1fkeggc"
        ],
        Bpf22ct: "f1wkmkig",
        apjfyd: "f18alut9"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f1063pyq{flex-direction:row;}",
        [
            ".fsbu5mz{gap:12px;}",
            {
                p: -1
            }
        ],
        ".fcgxt0o{margin-left:auto;}",
        ".f1ujusj6{margin-right:auto;}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1ndzpm5 .fui-Button,.f1ndzpm5 .fui-Link{border-top-color:currentColor;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1fkeggc .fui-Button,.f1fkeggc .fui-Link{border-right-color:currentColor;}.f1u45u6i .fui-Button,.f1u45u6i .fui-Link{border-left-color:currentColor;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f16eyofs .fui-Button,.f16eyofs .fui-Link{border-bottom-color:currentColor;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1wkmkig .fui-Button,.f1wkmkig .fui-Link{color:currentColor;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f18alut9 .fui-Button,.f18alut9 .fui-Link{outline-color:currentColor;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useCardFooterStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(cardFooterClassNames.root, styles.root, state.root.className);
    if (state.action) {
        state.action.className = (0, _react.mergeClasses)(cardFooterClassNames.action, styles.action, state.action.className);
    }
    return state;
}; //# sourceMappingURL=useCardFooterStyles.styles.js.map
